/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediqClassification
 */
export interface MediqClassification {
    /**
     * 
     * @type {string}
     * @memberof MediqClassification
     */
    code?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MediqClassification
     */
    values?: Array<string>;
}

/**
 * Check if a given object implements the MediqClassification interface.
 */
export function instanceOfMediqClassification(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MediqClassificationFromJSON(json: any): MediqClassification {
    return MediqClassificationFromJSONTyped(json, false);
}

export function MediqClassificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediqClassification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'values': !exists(json, 'values') ? undefined : json['values'],
    };
}

export function MediqClassificationToJSON(value?: MediqClassification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'values': value.values,
    };
}

